<template>
  <div class="Reports__View">
    <EntityListLayout v-if="tabs.length" :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>קופונים</template>
      <template #button>
        <a @click="addCoupon" class="link-button">
          הוספת קופון
        </a>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import AdminService from "@/services/AdminService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import CouponEntity from "@/views/CouponEntity.vue";
import DialogAddCoupon from '@/components/DialogAddCoupon.vue';
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import FieldService from "@/services/FieldService";
export default {
  name: "Reports",
  data() {
    return {
      tabs: [],
    };
  },
  components: {
    EntityListLayout,
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const lessonsFields = FieldService.list("coupons");

      const sideViewEntity = {
        component: CouponEntity,
        preview: true,
        readOnly: !this.isAdmin,
        title: "פרטי קופון",
        recordUrl: "books",
        recordTitle: "הצג קופון",
        hideRecord: true
      };
      const fields = [
        { ...lessonsFields.Id, checked: true },
        { ...lessonsFields.Name, checked: true },
        { ...lessonsFields.Code, checked: true },
        { ...lessonsFields.DiscountPercentage , checked: true },
        { ...lessonsFields.DiscountAmount , checked: true },
        { ...lessonsFields.ExpirationDate, checked: true },
        { ...lessonsFields.RemainingUses, checked: true },
        { ...lessonsFields.Status, checked: true },
      ];

      this.tabs = [
        {
          id: "AllCoupons",
          isPrimary: true,
          title: "כל הקופונים",
          getDataAsync: this.getAllCoupons,
          perPage: 100,
          fields,
          filters: null,
          sortField: "Id",
          sortOrder: "desc",
          checkableRows: false,
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש מהיר",
          },
          sideViewEntity,
        },
      ];
    },
    addCoupon() {
      Modal.open({
        component: DialogAddCoupon,
        props: {
          store: this.$store
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    getAllCoupons({ ...rest }) {
      return AdminService.getAdminCoupons(rest).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
  },
};
</script>
<style scoped lang="scss">
.Reports__View{
  height: 100%;
}
.link-button {
  background: #00427e;
  border: none;
  border-radius: 3px;
  padding: 14px 25px;
  color: white;
  cursor: pointer;
}
// .not-activated-row {
//   background-color: #fff !important;
// }
</style>
